import { create } from 'zustand';

import { ScrollPositionState } from './use-scroll-position.model';

export const useScrollPositionStore = create<ScrollPositionState>((set) => ({
  positions: { preview: 0 },
  setPosition: (key, position) =>
    set((state) => ({ positions: { ...state.positions, [key]: position } })),
}));
